import { TaskData } from './../../providers/tasks/models';
import { DevicesProvider } from './../../providers/devices/devices';
import { ProvidersProvider } from './../../providers/providers/providers';
import { LocationProvider } from './../../providers/location/location';
import { TasksProvider } from './../../providers/tasks/tasks';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, AlertController, LoadingController } from 'ionic-angular';
import { TaskQL, Task } from '../../providers/tasks/models';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TaskPhotosPage } from '../task-photos/task-photos';
import { TaskSchedulePage } from '../task-schedule/task-schedule';
import { TaskQuestionsPage } from '../task-questions/task-questions';
import { TaskCodePage } from '../task-code/task-code';
import { TaskTestPage } from '../task-test/task-test';
import { TaskCancelPage } from '../task-cancel/task-cancel';
import { TaskDeclinePage } from '../task-decline/task-decline';
import { TaskNotesPage } from '../task-notes/task-notes';
import { TaskCompletePage } from '../task-complete/task-complete';
import { Provider } from '../../providers/providers/models';
import { TaskTestSecurityPage } from '../task-test-security/task-test-security';
import { TaskTestFirealarmPage } from '../task-test-firealarm/task-test-firealarm';
import { ControlsGeyserPage } from '../controls-geyser/controls-geyser';
import { ProfilePage } from '../profile/profile';
import { User } from './../../providers/auth/models';

import { getValue } from '../../providers/tasks/filters'
import { UtilsProvider } from '../../providers/utils/utils';
import { AuthProvider } from '../../providers/auth/auth';
import { Observable } from 'rxjs'; 

declare let google;

@IonicPage()
@Component({
  selector: 'page-task-detail',
  templateUrl: 'task-detail.html'
})
export class TaskDetailPage {
  //@ViewChild('map') mapElement: ElementRef;
  public staleTask: TaskQL;
  public task: TaskQL;
  private map: any;
  private myLocation: any;
  private customer: any;
  private customerDetail: boolean = false;
  public taskData: TaskData;
  public deviceStateLoading: boolean = false;
  private loading: boolean = true;
  private providers: Provider[];
  private deviceReplace: any = false;
  private isRepair: boolean = false;
  private debug: boolean = true;
  public isUnscheduled: boolean = false;
  public currentUserTask: boolean = false;
  public bookingDelayed: boolean = false;
  public acceptanceCheck: boolean = false;
  private loader: any;
  public showDeclineButtonFeature: boolean = false;
  repairReason: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public tasksProvider: TasksProvider,
    private iab: InAppBrowser,
    private plt: Platform,
    private locationProvider: LocationProvider,
    private providersProvider: ProvidersProvider,
    private devicesProvider: DevicesProvider,
    private alertCtrl: AlertController,
    private utilsProvider: UtilsProvider,
    private authProvider: AuthProvider,
    public loadingCtrl: LoadingController,
  ) {
    this.task = this.navParams.get('task');
  }

  getRepairReason(){
    if(this.task.type === 'repair' && this.task.notes && this.task.notes.length > 0){
      let noteTime, noteObj;
      this.task.notes.forEach(note => {
        if(!noteTime || noteTime > note.timestamp){
          noteTime = note.timestamp;
          noteObj = note;
        }
      });
      this.repairReason = noteObj.note;
    }
  }

  ionViewDidLoad() {}

  loadMap(){
    //setTimeout(() => {
    //  this.map = this.locationProvider.loadMap(this.map, [this.task], this.currentUserTask, this.mapElement)
    //}, 100);
  }
  async ionViewDidEnter() {
    const taskNewNote = this.navParams.get('taskNewNote');
    if(taskNewNote){
      this.task = taskNewNote;
    }
     

    if(!this.task) {
      setTimeout(() => {
        this.getFreshTask();
      }, 10000)
    }
    if (this.task.status == Task.StatusEnum.Unscheduled || this.task.status == Task.StatusEnum.ToReschedule) { 
      this.getFreshTask()
    } else {
      const taskData = this.tasksProvider.getTaskData(this.task.id);
      if(taskData) { 
        this.taskData = {...taskData}; 
        await this.tasksProvider.hasTaskDiagnosticTestsBeenSkipped(this.task.id).subscribe(res => {
          this.taskData.skippedTests = res.testOverridden;
        });
      }
      this.pageOpened();
    }
  }

  getFreshTask(){
    const id = this.task.id;
    this.task = null;

    this.presentLoading('Loading Task')
    this.tasksProvider.getTask(id).subscribe(res => {
      this.loader.dismiss();
      this.task = res;
      this.pageOpened();
    });
  }

  pageOpened() {
    this.utilsProvider.userSyncCheck();
    this.getRepairReason();
    this.bookingDelayCheck();
    //this.loadMap();
    const fromSchedulePage = this.navParams.get('fromSchedulePage');
    this.currentUserTask = this.task.userId === this.authProvider.getUserId(); // && fromSchedulePage !== true
    
    if(this.task.status === Task.StatusEnum.Scheduled) this.checkAndScan();
    this.acceptanceCheck = this.acceptJobCheck(this.task);
    this.isUnscheduled = this.task.status === Task.StatusEnum.Unscheduled || this.task.status === Task.StatusEnum.ToReschedule;

    this.providersProvider.getProviders().subscribe(providersResult => {
      this.providers = providersResult;
      this.taskData = this.tasksProvider.getTaskData(this.task.id);
            this.isRepair = this.task.type.toLowerCase() == 'repair';

      if (this.taskData.deviceReplace) this.deviceReplace = this.taskData.deviceReplace;

      this.loading = false;

      if (this.task.deviceType === Task.DeviceTypeEnum.FireAlarm && this.task.type === 'repair') {
        // only on firealarm repairs
        this.deviceReplace = true;
        this.updateReplace();
        if (!this.taskData.testrepair) {
          this.tasksProvider.updateTaskData(this.task, 'testrepair', 'error').subscribe(data => {
            // done
            this.taskData = this.tasksProvider.getTaskData(this.task.id);
          });
        }
      }

      this.checkCode();
      this.replaceControlerHandle();
    });
  }

  ngOnChanges() {
    console.log('Model changed!!:', this.deviceReplace);
  }

  updateReplace() {
    this.tasksProvider.updateTaskData(this.task, 'deviceReplace', this.deviceReplace).subscribe(data => {
      if (this.deviceReplace) {
        // remove the test if device has to be replaced
        // this.tasksProvider
        //   .updateTaskData(this.task, 'test', null)
        //   .subscribe(data => {});
      }
      this.taskData = this.tasksProvider.getTaskData(this.task.id);
    });

    this.checkCode();
  }

  scheduleCheck() {
    const uid = this.authProvider.getUserId();
    const availableCheck = this.utilsProvider.hideTaskFromUser(this.task);
    if (!availableCheck) {
      this.openModule('schedule');
    } else {
      this.handleJobExpired();
    }
  }

  checkCode() {
    let code;
    let test;

    if (this.isRepair && this.taskData.verified) {
      if (this.deviceReplace) {
        if (this.taskData && this.taskData.newSerial) {
          this.tasksProvider.updateTaskData(this.task, 'code', this.taskData.newSerial).subscribe(data => {
            this.taskData = this.tasksProvider.getTaskData(this.task.id);
          });
        }
        
      } else {
        code = this.taskData.testrepair && this.taskData.testrepair !== 'error' ? this.taskData.verified : null;
        test = this.taskData.testrepair && this.taskData.testrepair !== 'error' ? this.taskData.testrepair : null;
          this.taskData.code = code;
          this.taskData.test = test;
          this.tasksProvider.updateTaskData(this.task, 'code', code).subscribe(data => {
            this.tasksProvider.updateTaskData(this.task, 'test', test).subscribe(data => {
              this.taskData = this.tasksProvider.getTaskData(this.task.id);
            });
          });
      }
    }
    // this.task_obj = this.dataProvider.getCurrentTask(this.task.key);
  }

  fireAlarmRepair() {
    return this.task.deviceType === Task.DeviceTypeEnum.FireAlarm && this.task.type === 'repair';
  }

  expandCustomer() {
    this.customerDetail = false;
  }

  getDeviceType(task: TaskQL) {
    return this.devicesProvider.getDeviceTypeLabel(task.deviceType);
  }

  hasAllPhotos(){
    if(this.task && this.task.deviceType && this.taskData && this.taskData.photos){
      const count = this.taskData.photos.filter(task => task.data && task.data !== null);
      const device = this.task.deviceType;
      return count.length >= 3;
    }
    return false
  }

  deviceControls(evt: Event, serial) {
    // const serial = type === 'codereplace'
    //   ? this.devicesProvider.getSerial(this.taskData.verified)
    //   : this.devicesProvider.getSerial(this.taskData.code);
    evt.preventDefault();
    evt.stopPropagation();

    const module = this.task.deviceType === Task.DeviceTypeEnum.Geyser ? ControlsGeyserPage : (this.task.deviceType === Task.DeviceTypeEnum.Congey ? ControlsGeyserPage : null);
    if (module) {
      this.navCtrl.push(module, {
        task: this.task,
        serial: serial
      });
    }
  }

  openModule(type, buttonExtra = "") {
    let module;
    let extras: any = { isrepair: false, isreplace: false };

    const testController =
      this.task.deviceType === Task.DeviceTypeEnum.Security
        ? TaskTestSecurityPage
        : this.task.deviceType === Task.DeviceTypeEnum.FireAlarm
        ? TaskTestFirealarmPage
        : TaskTestPage;

    if(this.task.type === 'repair' &&
      this.deviceReplace &&
      type === 'test'
      ){
      extras = { isrepair: false, isreplace: true };
    }

    if(this.task.type === 'repair' &&
      (this.task.deviceType === 'geyser' || this.task.deviceType === 'congey') &&
      !this.deviceReplace &&
      type === 'test'){
      type = 'testrepair';
    }

    switch (type) {
      case 'schedule':
        module = TaskSchedulePage;
        break;
      case 'photos':
        module = TaskPhotosPage;
        break;
      case 'questions':
        module = TaskQuestionsPage;
        break;
      case 'code':
        module = TaskCodePage;
        break;
      case 'coderepair':
        module = TaskCodePage;
        extras = { isrepair: true, isreplace: false };
        break;
      case 'codereplace':
        module = TaskCodePage;
        extras = { isrepair: false, isreplace: true };
        break;
      case 'test':
        module = testController;
        break;
      case 'testrepair':
        module = testController;
        extras = { isrepair: true, isreplace: false };
        break;
      case 'cancel':
        module = TaskCancelPage;
        const taskHadSwapOutAssigned = this.task && this.task.install && this.task.install.newSerial;
        const getSwapOutGeyserSerial = taskHadSwapOutAssigned || this.taskData.newSerial;
        extras = { hasNewSerial: getSwapOutGeyserSerial }
        break;
        case 'decline':
          module = TaskDeclinePage;
          break;
      case 'notes':
        module = TaskNotesPage;
        extras = {
          bookingDelayed: buttonExtra === 'delay',
          customerContact: buttonExtra === 'contact',
        };
        break;
      case 'user':
        module = ProfilePage;
        extras = { uid: buttonExtra };
        break;
      default:
        break;
    }
    if (module) {
      this.navCtrl.push(module, {
        task: this.task,
        customer: this.customer,
        extras
      });
    }
  }

  openMap() {
    console.log('openMap', this.task.address);
    /*let lat = this.task.address.latitude;
    let lng = this.task.address.longitude;
    let latlng = lat + ',' + lng;
    let url = '';
    if (!this.plt.is('cordova')) {
      url = 'https://maps.google.com/?q=' + latlng;
    } else if (this.plt.is('ios')) {
      url = 'http://maps.apple.com/maps?ll=' + latlng;
    } else if (this.plt.is('android') || this.plt.is('windows')) {
      url = 'geo:?q=' + latlng;
    }
    this.iab.create(url, '_system', 'location=true');*/
  }

  doAction() {
    // TODO
    // this.navCtrl.push(TaskAction, { animate: true, direction: 'forward' });
  }

  getPreInstallTemp(done) {
    const params = {
      limit: 20,
      filters: {
        service: { _eq:  this.task.service },
        _and: { type: {_eq: "installation"} }
      }
    };
    this.tasksProvider.getTasks(params,false).subscribe(
      data => {
        let tasks = getValue(data,'items')
        if(tasks){
          const taskItem = tasks.filter(task => task && task.install && task.install.serial === this.taskData.code);
          let question = getValue(taskItem,'0.install.questionsAnswers');
          question = question? question.find(q => q.question.includes('original thermostat')) : null;
          question? done(question.answer) : done(false);
        } else {
          done(false);
        }
      });
  }

  async complete() {
    // TODO
    let serial = this.taskData.code

    if (this.taskData.newSerial) serial = this.taskData.newSerial;

    //TODO: Temp disable rssi check
    if (serial && serial.includes('Temp disable rssi check') && this.task.type === 'installation') {
      // if (serial && serial.includes('GEYSER') && this.task.type === 'installation') {
      this.deviceStateLoading = true;
      this.devicesProvider.getDeviceInfo(this.taskData.code).subscribe(result => {
        this.deviceStateLoading = false;
        const strength = getValue(result, 'state.reported.signalRssi');
        const signalRssi = strength ? strength : 0;

        if (signalRssi < 5) {
          let alert = this.alertCtrl.create({
            title: 'Alert',
            message: 'The RSSI signal strength is very low, we recommend that you fit an external aerial and then re-test. Alternatively, please just complete the job',
            buttons: ['OK']
          });
          alert.present();
        }
        this.navCtrl.push(TaskCompletePage, {
          task: this.task
        });

      });
    } else if (serial && (serial.includes('GEYSER') || serial.includes('CONGEY')) && this.task.type === 'deinstallation') {
      this.devicesProvider.resetDevice(serial);
      this.getPreInstallTemp(temp => {
        if (temp) {
          let alert = this.alertCtrl.create({
            title: 'Alert',
            message: 'Please set device temperature back to ' + temp + ' after deinstallation.',
            buttons: ['OK']
          });
          alert.present();
        }
        this.navCtrl.push(TaskCompletePage, {
          task: this.task
        });
      });
    } else {
      this.navCtrl.push(TaskCompletePage, {
        task: this.task
      });
    }
  }

  isValid() {
    let flag = false;

    if (this.taskData) {
      // Updated complete check for geyser repair
      if(this.task.deviceType === 'geyser' || this.task.deviceType === 'congey'){
        if(this.task.type === 'repair'){
          if (this.task.deviceType === 'congey' && !this.deviceReplace) {
            this.taskData.code = this.taskData.verified
          } 
          if(this.taskData.questions && this.taskData.code && this.taskData.test && this.taskData.photos){
            flag = true;
          }
          // if(this.taskData.questions && this.task.deviceType === 'congey' && this.taskData.test){
          //   flag = true;
          // }
        }
        if(this.task.type === 'deinstallation'){
          if(this.taskData.questions && this.taskData.code){
            flag = true;
          }
        }
      }

      const noPhotoNeeded = (this.task.type !== 'installation' && this.task.type !== 'repair' && this.task.deviceType === 'secdev' && !this.deviceReplace);

      if (
        (this.taskData.photos && this.taskData.questions && this.taskData.code) ||
        (noPhotoNeeded && this.taskData.questions && this.taskData.code) ||
        (this.taskData.code && this.taskData.code.includes('FIRE'))
      ) {
        if (!this.taskData.test) {
          // replace and deinstall dont need to be tested
          if (this.task.type === 'replace' || this.task.type === 'deinstallation' || this.taskData.skippedTests) flag = true;
        } else {
          flag = true;
        }
      }
    }
    return flag;
  }

  checkAndScan() {
    if(!this.currentUserTask) return;
    var ignoreID =  localStorage.getItem("confirmedAddressID");
    if (this.task.id === ignoreID) return;
    // If device is already scanned do not show popup
    this.taskData = this.tasksProvider.getTaskData(this.task.id)
    if(getValue(this.taskData,'code')) return;

    let installdate = new Date(Number(this.task.assignedDate)).getTime();
    let now = new Date().getTime();
    if ((now >= installdate + 60 * 60 * 1000 || now <= installdate)) {
      let message =
        "This task's scheduled time is different than the current time. Are you sure you are at " +
        this.task.address.streetAddress +
        '?';
      let alert = this.alertCtrl.create({
        title: 'Note',
        message: message,
        buttons: [
          {
            text: 'No',
            role: 'continue',
            handler: data => {
            }
          },
          {
            text: 'Yes',
            role: 'ok',
            handler: data => {
              localStorage.setItem("confirmedAddressID", this.task.id);
            }
          }
        ]
      });
      alert.present();
    }
  }

  showPicsButton(){
    if(this.task.deviceType === 'geyser' || this.task.deviceType === 'congey'){
      if(this.task.type === 'repair' && !this.deviceReplace){
        this.taskData.code = this.task.install.serial
      }
      if(this.task.type === 'deinstallation'){
        return false;
      }
    }
    return this.task.deviceType !== 'firealarm'
  }

  questionDisableCheck(){
    if (this.task.deviceType === 'geyser' || this.task.deviceType === 'congey' || !this.taskData.skippedTests) {
      if(this.task.type === 'repair'  && this.taskData){
        return !this.taskData.verified;
      }
    }
    return !(this.taskData && this.taskData.code)
  }

  replaceControlerHandle(){
    const replace = getValue(this.navParams,'data.fromTest.replace');
    if(replace){
      this.deviceReplace = true;
      this.updateReplace();
      if(this.taskData.questions && this.taskData.questions.length === 1){
        this.taskData.questions = null;
      }
    }
  }

  bookingDelayCheck(){
    this.bookingDelayed = false;
    if(this.task.status !== Task.StatusEnum.Unscheduled) return;
    const isCurrentUser = this.task.schedulerMeta?.acceptedSchedulerSnn === this.authProvider.userData.data.uid;
    if (this.task.schedulerMeta?.expiredTime === null || this.task.schedulerMeta?.expiredTime === undefined ) return;
    const remaining = this.task.schedulerMeta?.expiredTime - new Date().getTime();
    if(isCurrentUser && remaining < 0 && !this.bookingDelayReasonCheck()) this.bookingDelayed = true;
  }

  bookingDelayReasonCheck(){
    const note = this.task?.notes?.filter(note => {
      return note.note.includes('Booking Delay:');
    });
    return note?.length > 0;
  }

  acceptJobCheck(task: TaskQL){
    if(this.currentUserTask) return true;
    if(task.status === Task.StatusEnum.Scheduled) return true;

    const isCurrentUser = task.schedulerMeta?.acceptedSchedulerSnn === this.authProvider.userData.data.uid;
    const timeRunOut = new Date().getTime() > task.schedulerMeta?.expiredTime;

    if(task.schedulerMeta?.acceptedSchedulerSnn  !== null && task.schedulerMeta?.acceptedSchedulerSnn  !== undefined && !timeRunOut) {
      if(!isCurrentUser && !timeRunOut) this.handleJobAlreadyAccepted();
      return true;
    }
    return false;
  }

  acceptJob(accept: Boolean){
    if(!accept){
      this.tasksProvider.hideTask(this.task.id).subscribe(res => {this.navCtrl.pop()})
    } else {
      // check if job
      this.presentLoading('Loading');
      this.tasksProvider.getTask(this.task.id)
      this.tasksProvider.getTask(this.task.id).subscribe((taskResult: Task) => {
        const shouldHide = this.utilsProvider.hideTaskFromUser(taskResult);
        if(shouldHide === false){
          this.tasksProvider.acceptTask(this.task, undefined, true).subscribe(res => {
            this.loader.dismiss();
            if (res) {
              const shouldHide = this.utilsProvider.hideTaskFromUser(res);
              if(shouldHide === false){
                this.acceptanceCheck = true;
              } else {
                this.handleJobAlreadyAccepted();
              }
            } 
          });
        } else {
          this.handleJobAlreadyAccepted();
        }

      })


    }
  }


  presentLoading(content: string = '') {
    this.loader = this.loadingCtrl.create({
      content
    });
    this.loader.present();
  }

  handleJobAlreadyAccepted(){
    const message = 'Task Already Accepted';
    const alert = this.alertCtrl.create({
      title: 'Warning!',
      message: message,
      buttons: ['OK']
    });
    alert.present();
    alert.onDidDismiss(res => {
      this.loader.dismiss();
      this.navCtrl.pop();
    });
  }


  handleJobExpired(){
    const message = 'Task Expired';
    const alert = this.alertCtrl.create({
      title: 'Warning!',
      message: message,
      buttons: ['OK']
    });
    alert.present();
    alert.onDidDismiss(res => {
      this.loader.dismiss();
      this.navCtrl.pop();
    });
  }

  hideAcceptedTaskCheck(){
    if(this.utilsProvider.hideTaskFromUser(this.task)){
      this.handleJobAlreadyAccepted();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/task-detail/task-detail.ts